import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';

import './App.css';
import './lib/security-guards'; // disable right-click / dev-tools shortcuts

import { AuthProvider } from './context/AuthContext';
import { ClientAuthProvider } from './context/ClientAuthContext';
import AppRouter from './AppRouter';

/**
 * Application entry point.
 *
 * Wires up:
 *   • BrowserRouter
 *   • AuthProvider     — staff Google OAuth + RBAC
 *   • ClientAuthProvider — client portal sessions
 *   • AppRouter        — route table
 *   • Toaster          — global toast notifications (sonner)
 */
export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ClientAuthProvider>
          <AppRouter />
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: '#1a1d27',
                color: '#e4e6ee',
                border: '1px solid #2a2d3a',
              },
            }}
          />
        </ClientAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
